import { noop } from 'lodash';
// react-native-haptic-feedback looks up its native module as soon as it is
// imported, which throws on web. There are no haptics on web, so every
// trigger is a no-op.
export const triggerHapticFeedback = noop;
export const triggerOnScrollEndHapticFeedback = noop;
export const triggerSelectionHapticFeedback = noop;
export const triggerReleaseHapticFeedback = noop;
export const triggerInputErrorHapticFeedback = noop;
export const triggerSelectorPress = noop;
export const triggerTimePeriodChange = noop;
export const triggerChartSelectionFeedback = () => {
    'worklet';
};
